export var cssClassNames = {
    loaded: 'ng-lazyloaded',
    loading: 'ng-lazyloading',
    failed: 'ng-failed-lazyloaded',
};
export function removeCssClassName(element, cssClassName) {
    element.className = element.className.replace(cssClassName, '');
}
export function addCssClassName(element, cssClassName) {
    if (!element.className.includes(cssClassName)) {
        element.className += " " + cssClassName;
    }
}
export function hasCssClassName(element, cssClassName) {
    return element.className && element.className.includes(cssClassName);
}
//# sourceMappingURL=css.util.js.map